// LocalStorage-backed data layer for GCBC Finances App

const KEY = 'gcbc_finances_v1';

const DEFAULT_CATEGORIES = [
  { id: 'pastor-salary', name: 'Pastor Salary', budget: 3200, spent: 3200, icon: 'user-round' },
  { id: 'insurance', name: 'Insurance Bill', budget: 850, spent: 812, icon: 'shield' },
  { id: 'electric', name: 'Electric Bill', budget: 420, spent: 388, icon: 'zap' },
  { id: 'trash', name: 'Trash Bill', budget: 95, spent: 95, icon: 'trash-2' },
  { id: 'water', name: 'Water Bill', budget: 140, spent: 122, icon: 'droplets' },
  { id: 'printing', name: 'Printing Bill', budget: 180, spent: 145, icon: 'printer' },
  { id: 'grounds', name: 'Grounds', budget: 260, spent: 210, icon: 'trees' },
  { id: 'kitchen', name: 'Kitchen', budget: 320, spent: 278, icon: 'utensils' },
  { id: 'sunday-school', name: 'Sunday School', budget: 240, spent: 190, icon: 'book-open' },
  { id: 'special-events', name: 'Special Events', budget: 500, spent: 320, icon: 'calendar-heart' },
  { id: 'office-supplies', name: 'Office Supplies', budget: 150, spent: 88, icon: 'notebook-pen' },
  { id: 'cleaning-supplies', name: 'Cleaning Supplies', budget: 130, spent: 96, icon: 'spray-can' },
  { id: 'miscellaneous', name: 'Miscellaneous', budget: 200, spent: 74, icon: 'boxes' },
  { id: 'remodeling', name: 'Remodeling Projects', budget: 1200, spent: 640, icon: 'hammer' },
];

const DEFAULT_TRANSACTIONS = [
  { id: 't1', date: '2026-02-14', description: 'Sunday Tithes & Offerings', category: 'Income', amount: 4820, type: 'income' },
  { id: 't2', date: '2026-02-12', description: 'Duke Energy — Electric Bill', category: 'Electric Bill', amount: -388, type: 'expense' },
  { id: 't3', date: '2026-02-10', description: 'Pastor Salary — February', category: 'Pastor Salary', amount: -3200, type: 'expense' },
  { id: 't4', date: '2026-02-08', description: 'Kitchen Supplies — Sam\'s Club', category: 'Kitchen', amount: -142, type: 'expense' },
  { id: 't5', date: '2026-02-06', description: 'Sunday School Curriculum', category: 'Sunday School', amount: -95, type: 'expense' },
  { id: 't6', date: '2026-02-05', description: 'Fellowship Fund — Donation', category: 'Income', amount: 650, type: 'income' },
  { id: 't7', date: '2026-02-03', description: 'City Water Utility', category: 'Water Bill', amount: -122, type: 'expense' },
  { id: 't8', date: '2026-02-01', description: 'Building Fund Contribution', category: 'Income', amount: 1200, type: 'income' },
];

const DEFAULT_STATE = {
  categories: DEFAULT_CATEGORIES,
  transactions: DEFAULT_TRANSACTIONS,
  monthlyBudget: 8000,
  accounts: [
    { id: 'a1', name: 'General Fund — First National', type: 'Checking', balance: 24680.45 },
    { id: 'a2', name: 'Building Fund — Wells Fargo', type: 'Savings', balance: 51230.10 },
    { id: 'a3', name: 'Missions Fund', type: 'Savings', balance: 8420.75 },
  ],
};

export function loadState() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) {
      localStorage.setItem(KEY, JSON.stringify(DEFAULT_STATE));
      return DEFAULT_STATE;
    }
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_STATE, ...parsed };
  } catch {
    return DEFAULT_STATE;
  }
}

export function saveState(state) {
  localStorage.setItem(KEY, JSON.stringify(state));
}

export function updateCategories(categories) {
  const state = loadState();
  const next = { ...state, categories };
  saveState(next);
  return next;
}

export function updateMonthlyBudget(monthlyBudget) {
  const state = loadState();
  const next = { ...state, monthlyBudget };
  saveState(next);
  return next;
}

export function resetState() {
  localStorage.removeItem(KEY);
  return loadState();
}

export function formatUSD(n) {
  const num = Number(n || 0);
  return num.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 });
}
